<script setup>
import ProductsGrid from "@/components/molecules/ProductsGrid.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import {useRoute, useRouter} from 'vue-router';
import ProductsFilter from "~/components/organisms/ProductsFilter.vue";
import {useCustomFetch} from '~/composables/customFetch.js';

const route = useRoute()
const router = useRouter()
const props = defineProps({
  data: Object,
})

const products = ref(props.data.products_data.products)
const total = ref(props.data.products_data.total)
const pages = ref(props.data.products_data.pages)
const count = ref(props.data.products_data.count)
const per_page = ref(props.data.products_data.per_page)
const choseFilters = ref(props.data.chosen_filter)

const page = ref(parseInt(route.query.page ?? 1))
const sorting = ref(route.query.sorting ?? 'recommended');
const slug = ref('/' + route.params.slug.join('/'));
const openFilter = ref(0);

const grid = ref(null);

watch(() => page.value, () => {
  const url = new URL(window.location);
  url.searchParams.set('page', page.value);
  window.history.replaceState(null, '', url)
})

watch(() => sorting.value, () => {
  const url = new URL(window.location);
  url.searchParams.set('sorting', sorting.value);
  window.history.replaceState(null, '', url)

  const event = new CustomEvent('urlReplaced', {
    detail: {
      message: '',
    },
  });

  window.dispatchEvent(event);
})

watch(() => slug.value, () => {
  fetchProducts()
})

const loadMore = (newPage) => {
  page.value = newPage
  fetchProducts(true)
}
const filterComponent = ref(null)
const loading = ref(false)

const changePage = (newPage) => {
  page.value = newPage
  fetchProducts(false)
}

const changeSorting = (newSorting) => {
  sorting.value = newSorting
  page.value = 1
  fetchProducts(false)
}

const filterChanged = (e) => {
  slug.value = e.slug
  page.value = 1
  choseFilters.value = e.chosenFilters
}

const removeFilter = (e) => {
  filterComponent.value.handleClick(e)
}

const clearFilter = (e) => {
  filterComponent.value.clearFilter(e)
}

const fetchProducts = async (concatenate = false) => {
  loading.value = true

  useCustomFetch(`/product-category${slug.value}`, {
    lazy: false,
    query: {page: page.value, sorting: sorting.value}
  }, true).then(({data}) => {
    if (concatenate) products.value = products.value.concat(data.data.products_data.products)
    else products.value = data.data.products_data.products

    total.value = data.data.products_data.total
    pages.value = data.data.products_data.pages
    count.value = data.data.products_data.count
    per_page.value = data.data.products_data.per_page

    if (!concatenate) {
      grid.value.scrollIntoView({behavior: 'smooth', block: 'start'})
    }

    loading.value = false
  })
}

</script>

<template>
  <div ref="grid">
    <ProductsFilter :openFilter="openFilter" ref="filterComponent" @change="filterChanged"/>
    <ProductsGrid @sortingChanged="changeSorting($event)" :total="total" @removeFilter="removeFilter"
                  @clearFilter="clearFilter"
                  @filter="openFilter=Math.random() * 100"
                  :currentSorting="sorting"
                  :chosenFilters="choseFilters"
                  :products="products"/>

    <Pagination :key="sorting" @change="changePage" :entity="$t('product.products')" :current-page="page"
                :count="count"
                :url="slug"
                :loading="loading"
                :loadMore="true" @more="loadMore"
                :items-per-page="per_page" :total-items="total"
                :total-pages="pages"/>
  </div>
</template>

